import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./ReservedMessage.module.css";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import useHelpers from "@hooks/useHelpers";
import tryOtherAnimation from "@/pages/split-payment/assests/tryOther.json";
import Lottie from "lottie-react";
var ReservedMessage = function ReservedMessage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ReservedMessageWrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Lottie, {
    animationData: tryOtherAnimation,
    loop: false,
    className: "h-24 w-24"
  }), /*#__PURE__*/React.createElement("strong", null, t("error_apologize", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", null, t("car_booked_another_customer_one", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: "".concat(stl.btn, " !bg-primary-new text-white hover:bg-primary-new-hover"),
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, t("similar_cars", {
    ns: "web_checkout_cash"
  }))));
};
export default ReservedMessage;